<template>
    <div>
        <a href="#" class="nav-link" data-toggle="modal" data-target="#notification-modal" v-bind:class="{'pr-4': notifications.length > 0}">
            <i class="fas bell-size fa-bell mr-2"></i>
            <span class="badge badge-pill badge-danger badge notification-badge" v-if="notifications.length > 0">{{ notifications.length }}</span>
        </a>

        <!-- Modal -->
        <div class="modal fade" id="notification-modal" tabindex="-1" role="dialog" aria-labelledby="notificationModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="notificationModalLabel">Notificações</h5>
                        <a href="javascript:;" @click="markAsRead" class="text-primary">marcar todas como lidas</a>
                    </div>
                    <div class="modal-body">
                        <div class="">

                            <div class="mb-1 notification" v-for="notification in notifications" :key="notification.id">
                                <div class="font-weight-normal text-secondary">
                                    {{ notification.data.message }}
                                </div>
                                <div class="text-muted">
                                    <small>{{ notification.created_at | moment("from", "now") }}</small>
                                </div>
                            </div>

                            <div class="py-3 text-center" v-if="notifications.length == 0">
                                <h4>
                                    Nenhuma mensagem no momento
                                </h4>
                            </div>

                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    props: {
        userId: {
            type: Number,
        }
    },
    data() {
        return {
            notifications: [],
            time: null
        }
    },
    created() {
        // Load Notifications
        this.loadAllNotification();

        // Interval for Update
        this.time = setInterval(() => {
            this.loadAllNotification();
        }, 25000);

        // Listen
        Echo.private('App.User.' + this.userId)
            .notification((notification) => {
                this.loadAllNotification(true);
            });
    },
    beforeDestroy() {
        clearInterval(this.time)
    },
    methods: {
        // Notifications
        loadAllNotification(withToast = false) {
            axios.get('/notifications')
                .then(notifications => {
                    this.notifications = notifications.data;
                    if (withToast) {
                        Vue.$toast.info(this.notifications[0].data.message, {
                            position: 'bottom-left',
                            duration: 10000
                        });
                    }
                })
                .catch(error => {

                });
        },
        // Mark As Read
        markAsRead() {
            axios.post('/notifications/mark-as-read')
                .then(result => {
                    this.loadAllNotification();
                })
                .catch(error => {

                });
        }
    }
}
</script>

<style>
.bell-size {
    margin-top: 4px;
    font-size: 1.16rem;
}
.notification-badge {
    position: absolute;
    margin-left: -7px;
}
.notification {
    padding: 10px;
}
.notification:hover {
    background: #F8F8F8;
}
</style>
